import React from "react";
import {Search} from "lucide-react";
import {cn} from "./cn";

export interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({value, onChange, placeholder, className}) => (
    <div className={cn("relative", className)}>
        <Search size={16} strokeWidth={2} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-ink-faint"/>
        <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={cn(
                "w-full h-11 pl-10 pr-4 rounded-xl text-sm bg-surface-sunken border border-transparent text-ink",
                "placeholder:text-ink-faint outline-none transition-colors duration-150",
                "focus:bg-surface focus:border-primary focus:ring-4 focus:ring-primary-tint"
            )}
        />
    </div>
);
